import React from 'react';

import './top-button-style.scss';

import Fab from '@mui/material/Fab';
import ArrowUpwardIcon from '@src/componentsNew/Icons/Icons/ArrowUpwardIcon';

interface IProps {
  style?: any;
  isMobile: boolean;
  onClick?: () => void;
}

const TopButton = ({ style, isMobile, onClick }: IProps) => {
  return (
    <Fab id="top-btn" className={`${isMobile ? 'mobile' : 'desktop'}`} onClick={onClick}>
      <ArrowUpwardIcon />
    </Fab>
  );
};

export default TopButton;
